import { Component } from '@angular/core';
import { DeveloperProvider } from '../../providers/developers';
import { FlxValidators } from '../../utils/flx-validators';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { NavController, NavParams } from 'ionic-angular';
import { ToastProvider } from '../../providers/toast';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'online-demo-modal',
  templateUrl: 'online-demo-modal.html',
})
export class OnlineDemoModalPage {
  public viewOnlineDemoForm: FormGroup;
  public formProps;
  private subscriberSubmitForm: Subject<any> = new Subject<any>();

  constructor(
    private devProvider: DeveloperProvider,
    private toast: ToastProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,) {
    this.formProps = {
      "form": {
        "amount_requested": {
          "type": "currency",
          "req-currency": true,
          "req-placeholder": "$ Checkout amount",
          "placeholder": "$ Checkout amount",
          "params": {
            "min": 500,
            "max": 1000
          },
          "validations": {
            "wrongRequestedAmount": "We're sorry, the amount entered is incorrect.",
            "format": "Oops, wrong format",
            "required": "Oops, this is a required field.",
            "invalid": "Not valid!"
          }
        },
      },
      "validations_form": {
        "required": "Oops, this is a required field.",
        "invalid": "Not valid!",
        "format": "Oops, wrong format",
        "minlength": "Value is too small",
        "maxlength": "Value is too large"
      }
    }
    this.viewOnlineDemoForm = this.formBuilder.group({
      amount_requested: new FormControl('', [
        Validators.required,
        FlxValidators.numberValidator,
        FlxValidators.currencyMaxValidator(this.formProps.form.amount_requested.params.max),
        FlxValidators.minValueValidator(this.formProps.form.amount_requested.params.min)]
      ),
    });
  }

  handleApplyButtonClick(option) {
    const amountRequested = (option === 'applyAndBuy') ? this.viewOnlineDemoForm['_value']['amount_requested'].replace(',', '').replace('$', '').replace(' ', '') : '';
    option === 'applyAndBuy' ? this.subscriberSubmitForm.next(true) : null;

    if (option !== 'apply' && !this.viewOnlineDemoForm.valid) return;

    this.devProvider.goToOnlinePortal(amountRequested)
      .subscribe(
        data => {
          let redirection_url = data['redirection_url'];
          window.open(redirection_url, '_system');

          this.navCtrl.pop();
        },
        error => {
          this.toast.create('Network is currently unavailable', 'error');
        });
  }
}



// WEBPACK FOOTER //
// ./src/pages/online-demo-modal/online-demo-modal.ts